import { jsx as _jsx } from "react/jsx-runtime";
import { FormAutocomplete } from "../../../../../forms/inputs/autocomplete/index.js";
import { FormAutocompleteModal } from "../../../../../forms/inputs/autocomplete-modal/index.js";
import useIsMobile from "../../../../../../hooks/device/useIsMobile.js";
import useDestinationInput from "./useDestinationInput.js";
const SearcherActivitiesDestinationInput = ()=>{
    const destinationInput = useDestinationInput();
    const isMobile = useIsMobile();
    if (isMobile) return /*#__PURE__*/ _jsx(FormAutocompleteModal, {
        ...destinationInput
    });
    return /*#__PURE__*/ _jsx(FormAutocomplete, {
        ...destinationInput
    });
};
export default SearcherActivitiesDestinationInput;

//# sourceMappingURL=index.js.map